<template>
    <Header />
    <Transition>
        <main class="opui-main opui-pt-6" :class="{ 'optpl-is-home': templateType === 'all', 'optpl-is-sub-page': templateType !== 'all' }" v-if="settingsStore.slLicenseIsValid">
            <div class="opui-container">
                <div class="opui-row">
                    <div class="opui-col" style="margin-bottom: 45px;">
                        <Hero @filter="filter" />
                    </div>
                </div>

                <div class="optpl-container" :class="{ 'optpl-container__filters-hidden': this.filtersStore.filtersHidden, 'optpl-container__my-templates': this.$route.params.type === 'my-templates', 'optpl-container__favorites': this.$route.params.type === 'favorites' }">
                    <a href="#" @click.prevent="this.filtersStore.filtersHidden = false" class="optpl-filter-toggle optpl-filter__show-filters" v-if="this.filtersStore.filtersHidden"><i class="opui-fa opui-fa-filter"></i> Show filters</a>

                    <div v-if="! this.filtersStore.filtersHidden" class="optpl-filters-container">
                        <div class="optpl-filter-header">
                            <a href="#" @click.prevent="this.filtersStore.filtersHidden = true" v-if="! this.filtersStore.filtersHidden" class="optpl-filter-toggle "><i class="opui-fa opui-fa-filter"></i> Hide filters</a>

                            <a href="#" @click.prevent="resetFilters" class="optpl-filter-toggle ">Reset</a>
                        </div>

                        <Filters @filter="filter" :groups="this.filtersStore.filterGroups" />
                    </div>

                    <div>
                        <SelectedFilters @filter="filter" v-if="templateType !== 'my-templates'" />

                        <TemplatesAreLoading v-if="this.templatesStore.loading" />
                        <Templates :groups="this.templatesStore.templateGroups" v-else />
                    </div>
                </div>
            </div>
        </main>
    </Transition>
</template>

<script>
import { useFiltersStore } from "../store/filters"
import { useSettingsStore } from "../store/settings"
import { useTemplatesStore } from "../store/templates"
import { mapStores } from 'pinia'
import Header from "../components/Global/Header.vue"
import Hero from "../components/Templates/Hero.vue"
import Filters from "../components/Templates/Filters.vue"
import SelectedFilters from "../components/Templates/SelectedFilters.vue"
import Templates from "../components/Templates/Templates.vue"
import TemplatesAreLoading from "../components/Loading/TemplatesAreLoading.vue"

export default {
    components: { Header, Hero, Filters, SelectedFilters, Templates, TemplatesAreLoading },
    computed: {
        ...mapStores(useFiltersStore, useSettingsStore, useTemplatesStore),
        templateType() {
            return this.$route.params.type || 'all'
        },
        isHome() {
            return this.$route.name === 'home'
        }
    },
    props: {
        loaded: { type: Boolean, default: false },
    },
    data() {
        return {
            filtersStore:   useFiltersStore(),
            templatesStore: useTemplatesStore(),
        }
    },
    mounted() {
        this.$events.on('resetFilters', () => {
            this.resetFilters()
        });

        window.scrollTo({ top: 0, behavior: 'instant' })
        this.$emit('filter')
    },
    methods: {
        filter() {
            this.$emit('filter')
        },

        resetFilters() {
            this.filtersStore.keyword = ''
            this.filtersStore.filterGroups.forEach(group => {
                group.filters.forEach(filter => {
                    filter.checked = false
                })
            })
            this.filter()
        },
    }
}
</script>
